class CardFormCtrl {
  [x: string]: any;

  static $inject = ['CardService', 'Card', 'StripeElements', '$scope', '$translate'];

  constructor(CardService, Card, StripeElements, $scope, $translate) {
    this.Card = Card;
    this.CardService = CardService;
    this.$scope = $scope;
    this.StripeElements = StripeElements;
    this.$translate = $translate;
  }

  $onInit() {
    let elements = this.StripeElements.elements({locale: this.$translate.preferredLanguage()});
    let style = {
      base: {
        color: '#55595c',
        '::placeholder': {
          color: '#969595',
          fontStyle: 'normal'
        }
      }
    };
    this.cardStripeElement = elements.create('card', {style: style, hidePostalCode: true});
    this.cardStripeElement.on('change', (event) => {
      this.handleChange(event);
    });
    this.cardStripeElement.on('blur', () => {
      this.$scope.$apply();
      this.handleNotFinishedCard();
      this.cardValid({valid: !this.isInvalid()});
    });
    window['cardStripeElement'] = this.cardStripeElement
  }

  handleNotFinishedCard() {
    if (!this.cardStripeElement._complete && !this.cardErrors) {
      this.cardErrors = this.$translate.instant('PLANS.CARD_COMPLETE_DATA');
    }
  }

  handleChange(e) {
    this.cardErrors = e.error && e.error.message;
    this.$scope.$apply();
    this.cardValid({valid: !this.isInvalid()});
  }

  isInvalid() {
    return (!this.cardStripeElement._complete || this.cardStripeElement._invalid || (!!(this.cardErrors)));

  }

  save() {
    if (!this.isInvalid()) {
      this.saving = true;
      return this.CardService.save(this.cardStripeElement).then(() => this.success()).catch(() => this.saving = false);
    }
  }

  success() {
    this.saving = false;
    this.cardChanged();
  }

  cancel() {
    this.cardStripeElement.clear();
    this.cardChanged();
  }
}

export default {
  controller: CardFormCtrl,
  template: require('./card.form.html'),
  bindings: {
    cardChanged: "&",
    cardValid: "&",
    card: "=",
    cardStripeElement: "=",
    showSteps: "<"
  }
}
